"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.checkValidCEP = function (cep) {
  var regex = /^\d{2}.\d{3}-\d{3}$/;
  var invalidsCEP = ['00000000', '11111111', '22222222', '33333333', '44444444', '55555555', '66666666', '77777777', '88888888', '99999999'];
  if (!cep) return false;
  if (!cep.match(regex)) return false;
  cep = cep.replace(/[^\d]+/g, '');
  if (cep.length !== 8) return false;
  if (invalidsCEP.indexOf(cep) > -1) return false;
  return true;
};